import { ViewController } from 'elc-service';
import {
    IShadePickeComponentControllerConfig,
    IShadePickerComponentConfig,
    IShadePickerDropdownConfig
} from '../interfaces/IShadePicker';
import { computed, action } from 'mobx';
import { ComponentTypes } from '../constants/ComponentTypes';

export class ProductShadePickerComponentViewController extends ViewController {
    private config: IShadePickerComponentConfig;
    private componentType: ComponentTypes;

    @action
    public initialize = (props: IShadePickeComponentControllerConfig) => {
        const { componentType, config } = props;
        this.componentType = componentType;
        this.config = config as IShadePickerComponentConfig;
    };

    @computed
    public get componentConfig() {
        if (!this.config.shadeDropdown) {
            return {};
        }
        const { overrides, ...shadeDropdownsConfig } = this.config
            .shadeDropdown as IShadePickerDropdownConfig;

        const configOverrides = overrides && overrides[this.componentType];

        return { ...shadeDropdownsConfig, ...configOverrides };
    }

    @computed
    get data() {
        return {
            componentConfig: this.componentConfig
        };
    }
}
